/**
 * Vonq package resource entrypoint.
 * Careful what you want to expose to the package consumer.
 */
import * as VonqInjector from '../private/VonqInjector.js';
import * as VonqApi from '../private/VonqApi.js';
import * as VonqPagination from '../private/util/Pagination.js';

export function init(callback, elementId) {
    // VonqInjector.inject(callback, elementId);
}

export function api(props) {
    return VonqApi.execute(props);
}

export function _api() {
    return window.HapiApi;
}

export function getPagination() {
    return VonqPagination.getPagination();
}

export function synchronousPromises(promises) {
    if (promises) {
        return new Promise(async (success) => {
            for (let i = 0; i < promises.length; i++) {
                await promises[i];
            }
            success();
        });
    }
}